import React from 'react';
import PropTypes from 'prop-types';

import { getStep } from '../../api';
import asset from '../../assetLoader';

import noEndCapImage from '../../assets/images/no-endcap.jpg';

import ProductRadio from '../../ProductRadio';

class EndCaps extends React.PureComponent {
  state = {
    products: [],
  };

  componentDidMount() {
    if (!this.props.values.end_caps) {
      this.props.setError('end_caps', 'required');
    }

    getStep({ ...this.props.values, step: this.props.step }, this.props.setLoading)
      .then(
        (res) => {
          this.setState({
            products: res,
          });
        },
        (error) => {
          console.log(error);
          this.props.setError('generic', error);
        }
      );
  }

  componentWillUnmount() {
    if (this.props.errors.end_caps) {
      this.props.setError('end_caps');
    }
  }

  handleChange = (name, value) => {
    if (value !== 0) {
      if (!value) {
        this.props.setError(name, 'required');
      } else {
        this.props.setError(name);
      }

      const product = this.state.products.find((product) => product.id === value);

      this.props.setValue('extras', {
        ...this.props.values.extras,
        end_caps: product.price.raw * this.props.values.quantity * 2,
      });
    } else {
      const { end_caps, ...extras } = this.props.values.extras;
      this.props.setError(name);

      this.props.setValue('extras', extras);
    }
  };

  render() {
    return (
      <div id="mtm-end-caps" className="row small-up-2 medium-up-3 mediumlarge-up-4 large-up-3 xlarge-up-4 mtm-grid">
        <ProductRadio
          fieldName="end_caps"
          value={0}
          name="Rakkapad (vassa kanter)"
          image={`<img src="${asset(noEndCapImage)}" alt="Rakkapad" />`}
          price={`${this.props.values.quantity * 2} × Ingår`}
          onChange={this.handleChange}
        />
        {this.state.products.map((product) => (
          <ProductRadio
            key={product.id}
            fieldName="end_caps"
            value={product.id}
            name={product.name}
            image={product.image.html}
            price={`${this.props.values.quantity * 2} × ${product.price.string}`}
            onChange={this.handleChange}
          />
        ))}
      </div>
    );
  }
}

EndCaps.propTypes = {
  step: PropTypes.number.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default EndCaps;





// WEBPACK FOOTER //
// ./src/Step/steps/EndCaps.js